export default __webpack_public_path__ + "static/Tek_Triangle_Foundation-3cee5e7488ab5d953c78459fc5d03f29.png";